export const localStorageKey = {
  lastLoginEmail: 'lastLoginEmail',
  deviceID: 'deviceID',
};
